import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import SubjectController from './subject';

export default class PlpController extends SubjectController {
  @action
  setCategoryBadgeDescription(value) {
    this.categoryBadgeDescription = value;
  }

  @action
  setCategoryBadgeUri(value) {
    this.categoryBadgeUri = value;
  }

  @action
  setCategoryDescription(value) {
    this.categoryDescription = value;
  }

  @action
  setCategoryLabel(value) {
    this.categoryLabel = value;
  }

  @action
  setSelectedSchool(value) {
    this.selectedSchool = value;
  }

  @action
  setSubcategoryDescription(value) {
    this.subcategoryDescription = value;
  }

  @action
  setSubcategoryLabel(value) {
    this.subcategoryLabel = value;
  }

  @tracked
  categoryBadgeDescription;

  @tracked
  categoryBadgeUri;

  @tracked
  categoryDescription;

  @tracked
  categoryLabel;

  @tracked
  selectedSchool;

  @tracked
  subcategoryDescription;

  @tracked
  subcategoryLabel;

  isPLP = true;
}
